/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kind_Muddy_Stingray_PinchInputs */

const fr_kind_muddy_stingray_pinch = /** @type {(inputs: Kind_Muddy_Stingray_PinchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune section pour cette séance a été trouvée`)
};

/**

* @param {Kind_Muddy_Stingray_PinchInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const kind_muddy_stingray_pinch = /** @type {((inputs?: Kind_Muddy_Stingray_PinchInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kind_Muddy_Stingray_PinchInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_kind_muddy_stingray_pinch(inputs)
});